import { UnitSystem } from "src/app/shared/enums/unit-system.enum";
import { BehaviorSubject } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable, Subject } from "rxjs";
import { toSimulationNodeData } from "src/app/shared/components/header-modals/save-simulation-modal/save-simulation-modal.component";

@Injectable({
  providedIn: "root",
})
export class GeothermalService {
  // Unit system communication
  private unitSystemSource$ = new BehaviorSubject<UnitSystem>(UnitSystem.USC);
  unitSystem$ = this.unitSystemSource$.asObservable();

  private dcpProductSource$: Subject<any> = new Subject<any>();
  dcpProduct$ = this.dcpProductSource$.asObservable();

  private closeDcpModalSource$: Subject<boolean> = new Subject<boolean>();
  closeDcpModal$ = this.closeDcpModalSource$.asObservable();

  constructor(private http: HttpClient) {}

  setUnitSystem(unit: UnitSystem) {
    this.unitSystemSource$.next(unit);
  }

  getUnitSystem(): UnitSystem {
    return this.unitSystemSource$.getValue();
  }

  setDcpProduct(dcpProduct: any) {
    this.dcpProductSource$.next(dcpProduct);
  }

  setCloseDcpModal(closeDcpModal: boolean) {
    this.closeDcpModalSource$.next(closeDcpModal);
  }

  calculate(request: any): Observable<any> {
    const url = `${environment.apiEndpoint}geothermal/v1/geothermal/calculate`;
    return this.http.post(url, JSON.stringify(request), {
      headers: { "Content-Type": "application/json" },
    });
  }

  saveSimulation(formData: any, saveSimulationForm: any): Observable<any> {
    const url = `${environment.apiEndpoint}geothermal/v1/geothermal/save`;

    const body = JSON.stringify({
      calculationData: formData,
      simulationNodeData: toSimulationNodeData(saveSimulationForm),
    });

    return this.http.post(url, body, {
      headers: { "Content-Type": "application/json" },
    });
  }

  // Load a saved simulation by treeId (accepts number/string or nested objects)
  loadSimulation(treeRef: number | string | any): Observable<any> {
    const url = `${environment.apiEndpoint}geothermal/v1/Geothermal/get`;

    // Normalize to the numeric simulation id expected by the API
    let treeId: number | string | undefined = undefined;
    if (treeRef == null) {
      treeId = undefined;
    } else if (typeof treeRef === "number" || typeof treeRef === "string") {
      treeId = treeRef as number | string;
    }

    const body = JSON.stringify({ treeId });

    return this.http.post(url, body, {
      headers: { "Content-Type": "application/json" },
    });
  }
}
